import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';

const NotFound = ({
  icon = 'Illustration-search-services',
  iconSize,
  iconClassName,
  title = '',
  titleClassName,
  description = '',
  createText = '',
  onCreate = () => {},
  className,
  extraText = ''
}) => (
  <div
    className={cn('mx-auto flex h-full flex-col items-center justify-center sm:pt-8', className)}>
    {icon && <Icon icon={icon} size={iconSize} className={iconClassName} />}
    {title && (
      <p
        className={cn(
          '!px-4 !pb-1 text-center text-base font-600 text-primary-900',
          titleClassName
        )}>
        {title}
      </p>
    )}
    {description && (
      <p className="!px-4 text-center text-sm leading-6 text-neutral-600">{description}</p>
    )}
    {extraText && (
      <p className="mt-5 !px-4 text-center text-sm leading-6 text-neutral-600">{extraText}</p>
    )}
    {createText && (
      <Button
        text={createText}
        onClick={onCreate}
        icon="add-square-mono"
        iconSize={18}
        className="!mt-3"
        variant="link"
      />
    )}
  </div>
);

export default NotFound;
